module.exports = __webpack_public_path__ + "static/img/145.f5a0be56.gif";